import { render, staticRenderFns } from "./UnlockCourse.vue?vue&type=template&id=58745316&scoped=true&"
import script from "./UnlockCourse.vue?vue&type=script&lang=js&"
export * from "./UnlockCourse.vue?vue&type=script&lang=js&"
import style0 from "./UnlockCourse.vue?vue&type=style&index=0&id=58745316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58745316",
  null
  
)

export default component.exports